import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-2 overflow-hidden text-ellipsis" }
const _hoisted_2 = { class: "sr-only" }

import { ref } from "vue";

import { getClasses } from "~/js/composables/classes";
import { getGlobalTranslation } from "~/js/composables/translations";

import { hasConsent } from "~/js/utils/cookie-script";

import TextH4 from "~/vue/atoms/texts/TextH4.vue";
import TextBody from "~/vue/atoms/texts/TextBody.vue";
import ButtonTertiary from "~/vue/atoms/buttons/ButtonTertiary.vue";

interface Props {
	background?: string;
	description?: string | null;
	heading: string;
	id: string;
	dateUpdated: string;
	categories: string[];
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardFileManagerConsent',
  props: {
    background: { default: "bg-white" },
    description: { default: null },
    heading: {},
    id: {},
    dateUpdated: {},
    categories: {},
    utilities: { default: "" }
  },
  emits: ["show-consent", "bypass"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const classes = ref({
	badge: {
		display: "inline-block",
		margin: "mb-2",
	},
	header: {
		size: "w-full",
	},
	footer: {
		flex: `flex items-center justify-end`,
		size: "w-full",
	},
	meta: {
		color: "text-concrete-700",
		font: "font-primary text-sm font-bold",
		lineHeight: "leading-relaxed",
		padding: "space-x-2",
	},
	wrapper: {
		animation: "transition-all duration-700",
		background: props.background,
		display: "rounded-3xl cursor-pointer relative",
		flex: "flex flex-col justify-between",
		focus: `focus:shadow-2xl`,
		hover: `group hover:shadow-2xl`,
		padding: "p-6 space-y-6",
		utilities: props.utilities,
	},
});

const emit = __emit;

const onCheckConsent = () => {
	if (hasConsent(props.categories)) {
		emit("bypass", props.id); // already accepted
	} else {
		emit("show-consent", props.id); // show consent popup
	}

	console.log("Consent categories: ");
	console.log(hasConsent(props.categories));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(_unref(getClasses)(classes.value, 'wrapper'))
  }, [
    _createElementVNode("header", {
      class: _normalizeClass(_unref(getClasses)(classes.value, 'header'))
    }, [
      _createElementVNode("h1", _hoisted_1, [
        _createVNode(TextH4, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.heading), 1)
          ]),
          _: 1
        })
      ]),
      (__props.description)
        ? (_openBlock(), _createBlock(TextBody, {
            key: 0,
            size: "small",
            color: "text-concrete-700",
            utilities: "line-clamp-4 font-primary text-sm leading-relaxed pt-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.description), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("footer", {
      class: _normalizeClass(_unref(getClasses)(classes.value, 'footer'))
    }, [
      _createVNode(ButtonTertiary, {
        size: "small",
        type: "div",
        content: _unref(getGlobalTranslation)('Read more'),
        "icon-position": "after",
        utilities: "inline-flex"
      }, null, 8, ["content"])
    ], 2),
    _createElementVNode("span", {
      class: "z-1 absolute inset-0 !mt-0 cursor-pointer",
      onClick: onCheckConsent
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(getGlobalTranslation)("Read more about")) + " " + _toDisplayString(__props.heading), 1)
    ])
  ], 2))
}
}

})